import React, { Component } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import { Localized } from "fluent-react/compat";
import CallApi from "../../utils/CallApi";
import { splitStrLang } from "../../utils/utils";
import SnackBar from "../user/SnackBar";
import Description from "./Description";
import ClassNames from "classnames";
import PropTypes from "prop-types";
import Button from "./Button";
import moment from "moment";

import "react-phone-number-input/style.css";

class General extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navLang: splitStrLang(window.navigator.language).toUpperCase(),
      restaurantId: props.restaurantId,
      emailContact: props.emailContact,
      displayPopupDisabledApp: false,
      disabledApp: props.disabledApp,
      description: props.description,
      slogan: props.slogan,
      name: props.name,
      phone: props.phone,
      openSnackBar: false,
      valideMail: true,
      restaurantTimezone: props.restaurantTimezone,
      success: false,
      disabled: true,
      errors: "",
    };
    this.form = React.createRef();
  }

  componentDidMount() {
    this.setState({
      disabled:
        this.state.name && this.state.phone && this.state.emailContact
          ? false
          : true,
    });

    // check if app is disabled today -> today is really today
    if (
      this.props.disabledApp.active &&
      this.props.disabledApp.period !== "all"
    ) {
      this.disabledAppIsActive();
    }
  }

  /**
   * handle phone with phoneInput
   */
  isValidatedPhone = (phone) => {
    this.setState(
      {
        phone,
      },
      () => this.checkIfInputOk()
    );
  };

  validatorEmail = (email) => {
    const validatorEmail = new RegExp(/^[^\s@]+@[^\s@]+\.([^\s@]{2,})+$/);
    return validatorEmail.test(email.trim());
  };

  disabledAppIsActive = () => {
    const day = this.props.disabledApp.period;
    const today = moment().format("YYYY-MM-DD");
    if (day !== today) {
      this.setState(
        {
          disabledApp: {
            active: false,
            period: null,
          },
        },
        () => {
          this.submitDisabledApp();
        }
      );
    }
  };

  submitDisabledApp = async () => {
    try {
      await CallApi(
        "put",
        "restaurant/admin/info",
        this.state.restaurantId,
        { update: "disabled", disabled: this.state.disabledApp },
        window.localStorage.getItem("refreshToken")
      );
      this.props.onUpdateDisabledApp({
        disabledApp: this.state.disabledApp,
      });
      this.setState(
        {
          success: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1200);
        }
      );
    } catch (e) {
      this.setState(
        {
          errors: <Localized id="tr-admin-error-data-modify" />,
        },
        () => {
          setTimeout(() => {
            this.setState({
              errors: "",
            });
          }, 1200);
        }
      );
    }
  };

  handleInputChange = (e) => {
    e.preventDefault();
    const { target } = e;
    const { value, name } = target;

    if (name === "emailContact") {
      const valideMail = this.validatorEmail(value);
      return this.setState({ [name]: value, valideMail }, () =>
        this.checkIfInputOk()
      );
    }
    this.setState(
      {
        [name]: value,
      },
      () => this.checkIfInputOk()
    );
  };

  handleDisabledApp = (e, bool) => {
    e.preventDefault();

    this.setState({
      displayPopupDisabledApp: bool,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const info = {
      update: "general",
      name: this.state.name,
      emailContact: this.state.emailContact,
      description: this.state.description,
      phone: this.state.phone,
      slogan: this.state.slogan,
    };
    try {
      await CallApi(
        "put",
        "restaurant/admin/info",
        this.state.restaurantId,
        info,
        window.localStorage.getItem("refreshToken")
      );
      this.setState(
        {
          success: true,
          openSnackBar: true,
        },
        () => {
          setTimeout(() => this.props.onUpdateRestaurantGeneral(info), 2000);
        }
      );
    } catch (e) {
      this.setState(
        {
          errors: <Localized id="tr-admin-error-data-modify" />,
        },
        () => {
          setTimeout(() => {
            this.setState({
              errors: "",
            });
          }, 1200);
        }
      );
    }
  };

  checkIfInputOk = () => {
    const { name, phone, valideMail } = this.state;
    const checkInputs =
      isValidPhoneNumber(phone) && name && valideMail ? false : true;
    this.setState({ disabled: checkInputs });
  };

  handleCloseSnack = () => {
    this.setState({ openSnackBar: !this.state.openSnackBar });
  };

  render() {
    return (
      <div className="pure-g">
        <div className="container general">
          <div className="pure-u-md-18-24 space-block">
            <form
              onSubmit={this.handleSubmit}
              noValidate
              className="pure-form"
              ref={this.form}
            >
              <label>
                <Localized id="tr-admin-name-restaurant" />
              </label>
              <input
                required
                data-cypress="name-restaurant"
                type="text"
                name="name"
                value={this.state.name ? this.state.name : ""}
                onChange={this.handleInputChange}
              />
              <label>
                <Localized id="tr-admin-email" />
              </label>
              <input
                className={this.state.valideMail ? "" : "error-input"}
                type="email"
                name="emailContact"
                required
                value={this.state.emailContact}
                onChange={this.handleInputChange}
              />
              <label>
                <Localized id="tr-title-phone" />
              </label>

              <PhoneInput
                className={`input-phone ${
                  this.state.phone && isValidPhoneNumber(this.state.phone)
                    ? ""
                    : "error-input"
                }`}
                country={this.state.navLang}
                defaultCountry="FR"
                placeholder="00 00 00 00 00"
                value={this.state.phone}
                onChange={(phone) => this.isValidatedPhone(phone)}
              />
              <label>
                <Localized id="tr-admin-concept" />
              </label>
              <input
                data-cypress="concept-restaurant"
                type="text"
                name="slogan"
                value={this.state.slogan}
                onChange={this.handleInputChange}
                maxLength={50}
              />
              <label>
                <Localized id="tr-admin-describe-concept" />
              </label>
              <Description
                handleInputChange={this.handleInputChange}
                value={this.state.description}
              />
              <label>
                Fuseau horaire
              </label>
              <input
                type="text"
                name="name"
                disabled
                value={this.state.restaurantTimezone}
              />
              <div className="submit">
                {this.state.openSnackBar ? (
                  <SnackBar
                    open={this.state.openSnackBar}
                    handleCloseSnack={this.handleCloseSnack}
                    text={<Localized id="tr-admin-change" />}
                    success={true}
                  />
                ) : (
                  ""
                )}
                {this.state.errors ? (
                  <p className="error">{this.state.errors}</p>
                ) : (
                  ""
                )}
                <Button
                  disabledSubmit={this.state.disabled}
                  submit={this.handleSubmit}
                  text={"tr-button-validate"}
                  classCusto={"is-red"}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  static defaultProps = {
    restaurantId: "1",
    disabledApp: {
      active: false,
      period: null,
    },
    name: "",
    phone: "",
  };
}

General.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  restaurant: PropTypes.string,
  slogan: PropTypes.string,
  phone: PropTypes.string,
  disabledApp: PropTypes.object.isRequired,
  emailContact: PropTypes.string,
  onUpdateRestaurantGeneral: PropTypes.func.isRequired,
  onUpdateDisabledApp: PropTypes.func.isRequired,
};
export default General;
